<template>
  <div class="flex vertical">
    <div class="chart-container flex jbetween">
      <div class="flex vertical flex-1 mr24">
        <div class="flex jbetween acenter">
          <div v-for="i in ['09', '10', '11']" class="average-box flex vertical flex-1 bg-white br6" :class="{ mr24: i !== '11' }">
            <div class="title-box flex jbetween">
              <div class="title-left flex acenter">
                <span class="title-text" v-if="getLang == 'en'">{{ $t(averageNameList[i - 9]) }} {{ infoData[`v_927400${i}`].month }}</span>
                <span class="title-text" v-else>{{ infoData[`v_927400${i}`].month }} {{ $t(averageNameList[i - 9]) }}</span>
              </div>
            </div>
            <div class="flex jbetween acenter pl24 pr47 mt31">
              <div class="flex vertical">
                <div class="flex aend">
                  <span class="font-16 color-1c fw-600">￥</span>
                  <span class="font-32 color-1c fw-600">{{ $showMoney(infoData[`v_927400${i}`].value) }}</span>
                </div>
                <div class="compare-box flex acenter mt18">
                  <span class="font-14 color-9 mr8">{{ $t('YoYLastMonth') }}</span>
                  <span class="font-14 fw-500 color-9 mr2" :class="`${$handleCompare(infoData[`v_927400${i}`].proportion)}-text`">{{ infoData[`v_927400${i}`].proportion || '0%' }}</span>
                  <img v-if="$handleCompare(infoData[`v_927400${i}`].proportion) !== 'equal'" :src="require(`@/assets/img/v2/common/arrow-${$handleCompare(infoData[`v_927400${i}`].proportion)}.png`)" class="arrow-img" />
                </div>
              </div>
              <img :src="require(`@/assets/img/v2/data-center/${averageNameList[i - 9]}.png`)" class="size70" />
            </div>
          </div>
        </div>
        
        <div class="left-chart-container flex vertical mt24 bg-white br6" v-loading="statsData.empChange.loading">
          <div class="title-box flex jbetween">
            <div class="title-left flex acenter">
              <span class="title-text mr8">{{ $t('statisticsOfChanges.title') }}</span> <!--员工人数变动统计-->
              <el-popover placement="top" :title="$t('illustration')" width="230" trigger="hover" :content="$t('statisticsOfChanges.illustration')">
                <img slot="reference" src="@/assets/img/v2/common/tips-gray.png" class="size14 mr32" />
              </el-popover>
              <div class="date-picker-v2">
                <el-date-picker v-model="statsData.empChange.monthRange" type="monthrange" format="yyyy-MM" value-format="yyyy-MM" :range-separator="$t('rangeSeparator')" start-placeholder="开始年月" end-placeholder="结束年月" prefix-icon="none" :clearable="false" :picker-options="statsData.empChange.pickerOptions" @change="getStatsData('empChange')"></el-date-picker>
                <img src="@/assets/img/v2/common/date.png" class="date-picker-icon" />
              </div>
            </div>
          </div>
          
          <emp-change-chart :chart-data="statsData.empChange.data" margin="17px 0 0 0"></emp-change-chart>
        </div>
      </div>
      
      <div class="right-chart-container flex vertical bg-white br6" style="height: 624px;" v-loading="infoLoading">
        <div class="title-box flex jbetween">
          <div class="title-left flex acenter">
            <span class="title-text mr8">{{ $t('nativePlaceDistribution.title') }}</span>
            <el-popover placement="top" :title="$t('illustration')" width="230" trigger="hover" :content="$t('nativePlaceDistribution.illustration')">
              <img slot="reference" src="@/assets/img/v2/common/tips-gray.png" class="size14 mr32" />
            </el-popover>
          </div>
        </div>
        
        <native-place-chart :chart-data="infoData" margin="17px 0 0 0" @sort-percent="nativePlaceSortPercent"></native-place-chart>
        
        <div v-if="nativePlacePercentList.length" class="progress-container flex vertical jbetween mt31 pl36 pr28" style="height: 156px; overflow: hidden;">
          <div class="progress-box flex jbetween acenter">
            <div class="size14 br2 mr8" style="background: #CDE8F0;"></div>
            <span class="font-14 color-9 mr15">{{ nativePlacePercentList[0].name }}</span>
            <el-progress class="flex-1" :percentage="nativePlacePercentList[0].percent" color="#CDE8F0" :stroke-width="10"></el-progress>
          </div>
          <div class="progress-box flex jbetween acenter">
            <div class="size14 br2 mr8" style="background: #A8D7E4;"></div>
            <span class="font-14 color-9 mr15">{{ nativePlacePercentList[1].name }}</span>
            <el-progress class="flex-1" :percentage="nativePlacePercentList[1].percent" color="#A8D7E4" :stroke-width="10"></el-progress>
          </div>
          <div class="progress-box flex jbetween acenter">
            <div class="size14 br2 mr8" style="background: #71C4D2;"></div>
            <span class="font-14 color-9 mr15">{{ nativePlacePercentList[2].name }}</span>
            <el-progress class="flex-1" :percentage="nativePlacePercentList[2].percent" color="#71C4D2" :stroke-width="10"></el-progress>
          </div>
          <div class="progress-box flex jbetween acenter">
            <div class="size14 br2 mr8" style="background: #41A7AD;"></div>
            <span class="font-14 color-9 mr15">{{ nativePlacePercentList[3].name }}</span>
            <el-progress class="flex-1" :percentage="nativePlacePercentList[3].percent" color="#41A7AD" :stroke-width="10"></el-progress>
          </div>
        </div>
      </div>
    </div>
    
    <div class="chart-container flex jbetween mt24">
      <div class="left-chart-container flex vertical flex-1 bg-white br6 mr24" v-loading="statsData.salaryMonth.loading">
        <div class="title-box flex jbetween">
          <div class="title-left flex acenter">
            <span class="title-text mr8">{{ $t('monthlyEmployeeSalaryStatistics.title') }}</span>
            <el-popover placement="top" :title="$t('illustration')" width="230" trigger="hover" :content="$t('monthlyEmployeeSalaryStatistics.illustration')">
              <img slot="reference" src="@/assets/img/v2/common/tips-gray.png" class="size14 mr32" />
            </el-popover>
            <div class="date-picker-v2">
              <el-date-picker v-model="statsData.salaryMonth.monthRange" type="monthrange" format="yyyy-MM" value-format="yyyy-MM" :range-separator="$t('rangeSeparator')" start-placeholder="开始年月" end-placeholder="结束年月" prefix-icon="none" :clearable="false" :picker-options="statsData.salaryMonth.pickerOptions" @change="getStatsData('salaryMonth')"></el-date-picker>
              <img src="@/assets/img/v2/common/date.png" class="date-picker-icon" />
            </div>
          </div>
          <div class="title-right flex acenter">
            <el-radio-group class="radio-group-v2" v-model="statsData.salaryMonth.type" size="small" @input="getStatsData('salaryMonth')">
              <el-radio-button label="sum">{{ $t('total') }}</el-radio-button>
              <el-radio-button label="avg">{{ $t('average') }}</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        
        <salary-month-chart :chart-data="statsData.salaryMonth.data" margin="17px 0 0 0"></salary-month-chart>
      </div>
      
      <div class="right-chart-container flex vertical bg-white br6" v-loading="statsData.salaryCompo.loading">
        <div class="title-box flex jbetween">
          <div class="title-left flex acenter">
            <span class="title-text mr8">{{ $t('salaryCompositionRatioStatistics.title') }}</span>
            <el-popover placement="top" :title="$t('illustration')" width="230" trigger="hover" :content="$t('salaryCompositionRatioStatistics.illustration')">
              <img slot="reference" src="@/assets/img/v2/common/tips-gray.png" class="size14 mr32" />
            </el-popover>
          </div>
          <div class="title-right flex acenter">
            <div class="date-picker-v2">
              <el-date-picker v-model="statsData.salaryCompo.year" type="year" :format="`yyyy${ $t('el.datepicker.year') }`" value-format="yyyy" placeholder="选择年份" prefix-icon="none" :clearable="false" @change="getStatsData('salaryCompo')"></el-date-picker>
              <img src="@/assets/img/v2/common/date.png" class="date-picker-icon" />
            </div>
          </div>
        </div>
        
        <div class="full flex center">
          <salary-compo-ratio-chart :chart-data="statsData.salaryCompo.data" margin="17px 0 0 0"></salary-compo-ratio-chart>
        </div>
      </div>
    </div>
    
    <div class="chart-container flex jbetween mt24">
      <div class="flex jbetween flex-1 mr24">
        <div class="left-chart-container small-chart flex vertical flex-1 bg-white br6 mr24" v-loading="statsData.salaryDist.loading">
          <div class="title-box flex jbetween">
            <div class="title-left flex acenter">
              <span class="title-text mr8">{{ $t('employeeSalaryDistributionStatistics.title') }}</span>
              <el-popover placement="top" :title="$t('illustration')" width="230" trigger="hover" :content="$t('employeeSalaryDistributionStatistics.illustration')">
                <img slot="reference" src="@/assets/img/v2/common/tips-gray.png" class="size14 mr32" />
              </el-popover>
              <div class="date-picker-v2">
                <el-date-picker v-model="statsData.salaryDist.year" type="year" :format="`yyyy${ $t('el.datepicker.year') }`" value-format="yyyy" placeholder="选择年份" prefix-icon="none" :clearable="false" @change="getStatsData('salaryDist')"></el-date-picker>
                <img src="@/assets/img/v2/common/date.png" class="date-picker-icon" />
              </div>
            </div>
            <div class="title-right flex acenter">
              <el-radio-group class="radio-group-v2" v-model="statsData.salaryDist.type" size="small" @input="getStatsData('salaryDist')">
                <el-radio-button label="sf">{{ $t('gross') }}</el-radio-button>
                <el-radio-button label="yf">{{ $t('net') }}</el-radio-button>
                <el-radio-button label="cb">{{ $t('cost') }}</el-radio-button>
              </el-radio-group>
            </div>
          </div>
          
          <div class="full flex center">
            <salary-dist-chart :chart-data="statsData.salaryDist.data" margin="17px 0 0 0"></salary-dist-chart>
          </div>
        </div>
        
        <div class="left-chart-container small-chart flex vertical flex-1 bg-white br6" v-loading="statsData.deptSalary.loading">
          <div class="title-box flex jbetween">
            <div class="title-left flex acenter">
              <span class="title-text mr8">{{ $t('departmentSalaryRatioStatistics.title') }}</span>
              <el-popover placement="top" :title="$t('illustration')" width="230" trigger="hover" :content="$t('departmentSalaryRatioStatistics.illustration')">
                <img slot="reference" src="@/assets/img/v2/common/tips-gray.png" class="size14 mr32" />
              </el-popover>
              <div class="date-picker-v2">
                <el-date-picker v-model="statsData.deptSalary.year" type="year" :format="`yyyy${ $t('el.datepicker.year') }`" value-format="yyyy" placeholder="选择年份" prefix-icon="none" :clearable="false" @change="getStatsData('deptSalary')"></el-date-picker>
                <img src="@/assets/img/v2/common/date.png" class="date-picker-icon" />
              </div>
            </div>
            <div class="title-right flex acenter">
              <el-radio-group class="radio-group-v2" v-model="statsData.deptSalary.type" size="small" @input="getStatsData('deptSalary')">
                <el-radio-button label="sf">{{ $t('gross') }}</el-radio-button>
                <el-radio-button label="yf">{{ $t('net') }}</el-radio-button>
                <el-radio-button label="cb">{{ $t('cost') }}</el-radio-button>
              </el-radio-group>
            </div>
          </div>
          
          <div class="full flex center pl20 pr36">
            <dept-salary-ratio-chart :chart-data="statsData.deptSalary.data" margin="17px 0 0 0"></dept-salary-ratio-chart>
          </div>
        </div>
      </div>
      
      <div class="right-chart-container flex vertical bg-white br6" v-loading="statsData.salaryType.loading">
        <div class="title-box flex jbetween">
          <div class="title-left flex acenter">
            <span class="title-text mr8">{{ $t('salaryTypeProportionStatistics.title') }}</span>
            <el-popover placement="top" :title="$t('illustration')" width="230" trigger="hover" :content="$t('salaryTypeProportionStatistics.illustration')">
              <img slot="reference" src="@/assets/img/v2/common/tips-gray.png" class="size14 mr32" />
            </el-popover>
          </div>
          <div class="title-right flex acenter">
            <div class="date-picker-v2">
              <el-date-picker v-model="statsData.salaryType.year" type="year" :format="`yyyy${ $t('el.datepicker.year') }`" value-format="yyyy" placeholder="选择年份" prefix-icon="none" :clearable="false" @change="getStatsData('salaryType')"></el-date-picker>
              <img src="@/assets/img/v2/common/date.png" class="date-picker-icon" />
            </div>
          </div>
        </div>
        
        <div class="full flex">
          <div v-if="Object.keys(statsData.salaryType.data.v_92740013).length === 0" class="w100 flex vertical center">
            <img src="@/assets/img/v2/data-center/custom-report-empty.png" style="width: 240px; height: 146px;" />
            <span class="font-16 fw-500 color-6 mt6 mb40">{{ $t('noData') }}</span>
          </div>
          
          <div v-else class="progress-container w100 flex vertical mt45 pl24 pr24" style="height: 280px;">
            <div v-for="(value, key) in statsData.salaryType.data.v_92740013" class="progress-box flex jbetween acenter mb43">
              <span class="wpx70 font-14 color-9 mr11 text-left text-ellipsis" :title="key">{{ key }}</span>
              <el-progress :percentage="value.replace('%', '')" color="#0093AB" :stroke-width="10"></el-progress>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="chart-container flex jbetween mt24">
      <div class="flex jbetween flex-1 mr24">
        <div class="left-chart-container small-chart flex vertical flex-1 bg-white br6 mr24" v-loading="statsData.empAge.loading">
          <div class="title-box flex jbetween">
            <div class="title-left flex acenter">
              <span class="title-text mr8">{{ $t('employeeAgeRatioStatistics.title') }}</span>
              <el-popover placement="top" :title="$t('illustration')" width="230" trigger="hover" :content="$t('employeeAgeRatioStatistics.illustration')">
                <img slot="reference" src="@/assets/img/v2/common/tips-gray.png" class="size14 mr32" />
              </el-popover>
            </div>
          </div>
          
          <div class="full flex center pl46 pr36">
            <emp-age-ratio-chart :chart-data="statsData.empAge.data" margin="17px 0 0 0"></emp-age-ratio-chart>
          </div>
        </div>
        
        <div class="left-chart-container small-chart flex vertical flex-1 bg-white br6" v-loading="statsData.empHireTime.loading">
          <div class="title-box flex jbetween">
            <div class="title-left flex acenter">
              <span class="title-text mr8">{{ $t('employeeServiceRatioStatistics.title') }}</span>
              <el-popover placement="top" :title="$t('illustration')" width="230" trigger="hover" :content="$t('employeeServiceRatioStatistics.illustration')">
                <img slot="reference" src="@/assets/img/v2/common/tips-gray.png" class="size14 mr32" />
              </el-popover>
            </div>
          </div>
          
          <div class="full flex center pl46 pr36">
            <emp-hire-time-ratio-chart :chart-data="statsData.empHireTime.data" margin="17px 0 0 0"></emp-hire-time-ratio-chart>
          </div>
        </div>
      </div>
      
      <div class="right-chart-container flex vertical bg-white br6" v-loading="statsData.costCenter.loading">
        <div class="title-box flex jbetween">
          <div class="title-left flex acenter">
            <span class="title-text mr8">{{ $t('costCenterProportionStatistics.title') }}</span>
            <el-popover placement="top" :title="$t('illustration')" width="230" trigger="hover" :content="$t('costCenterProportionStatistics.illustration')">
              <img slot="reference" src="@/assets/img/v2/common/tips-gray.png" class="size14 mr32" />
            </el-popover>
          </div>
          <div class="title-right flex acenter">
            <div class="date-picker-v2">
              <el-date-picker v-model="statsData.costCenter.year" type="year" :format="`yyyy${ $t('el.datepicker.year') }`" value-format="yyyy" placeholder="选择年份" prefix-icon="none" :clearable="false" @change="getStatsData('costCenter')"></el-date-picker>
              <img src="@/assets/img/v2/common/date.png" class="date-picker-icon" />
            </div>
          </div>
        </div>
        
        <div class="flex jend acenter mt18 mr24">
          <el-radio-group class="radio-group-v2" v-model="statsData.costCenter.type" size="small" @input="getStatsData('costCenter')">
            <el-radio-button label="sf">{{ $t('gross') }}</el-radio-button>
            <el-radio-button label="yf">{{ $t('net') }}</el-radio-button>
            <el-radio-button label="cb">{{ $t('cost') }}</el-radio-button>
          </el-radio-group>
        </div>
        
        <div class="full flex">
          <div v-if="Object.keys(statsData.costCenter.data.v_92740016).length === 0" class="w100 flex vertical center">
            <img src="@/assets/img/v2/data-center/custom-report-empty.png" style="width: 240px; height: 146px;" />
            <span class="font-16 fw-500 color-6 mt6 mb40">{{ $t('noData') }}</span>
          </div>
          
          <div v-else class="progress-container w100 flex vertical mt45 pl24 pr24" style="height: 220px;">
            <div v-for="(value, key) in statsData.costCenter.data.v_92740016" class="progress-box flex jbetween acenter mb43">
              <span class="wpx70 font-14 color-9 mr11 text-left text-ellipsis" :title="key">{{ key }}</span>
              <el-progress :percentage="value.replace('%', '')" color="#0093AB" :stroke-width="10"></el-progress>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div class="chart-container flex jbetween mt24">
      <div class="flex jbetween flex-1 mr24">
        <div class="left-chart-container small-chart flex vertical flex-1 bg-white br6 mr24" v-loading="statsData.empEducation.loading">
          <div class="title-box flex jbetween">
            <div class="title-left flex acenter">
              <span class="title-text mr8">{{ $t('educationDistributionStatistics.title') }}</span>
              <el-popover placement="top" :title="$t('illustration')" width="230" trigger="hover" :content="$t('educationDistributionStatistics.illustration')">
                <img slot="reference" src="@/assets/img/v2/common/tips-gray.png" class="size14 mr32" />
              </el-popover>
            </div>
          </div>
        
          <div class="full flex center pl46 pr36">
            <emp-education-ratio-chart :chart-data="statsData.empEducation.data" margin="17px 0 0 0"></emp-education-ratio-chart>
          </div>
        </div>
      
        <div class="left-chart-container small-chart flex vertical flex-1 bg-white br6" v-loading="statsData.empGender.loading">
          <div class="title-box flex jbetween">
            <div class="title-left flex acenter">
              <span class="title-text mr8">{{ $t('genderStatistics.title') }}</span>
              <el-popover placement="top" :title="$t('illustration')" width="230" trigger="hover" :content="$t('genderStatistics.illustration')">
                <img slot="reference" src="@/assets/img/v2/common/tips-gray.png" class="size14 mr32" />
              </el-popover>
            </div>
          </div>
        
          <div class="full flex center pl46 pr36">
            <emp-gender-ratio-chart :chart-data="statsData.empGender.data" margin="17px 0 0 0"></emp-gender-ratio-chart>
          </div>
        </div>
      </div>
    
      <div class="right-chart-container flex vertical br6"></div>
    </div>
    
  </div>
</template>

<script>
  import * as apiBoard from '@/api/v2/stats/data-center/board'
  import DeptSalaryRatioChart from './DeptSalaryRatioChart.vue'
  import EmpAgeRatioChart from './EmpAgeRatioChart.vue'
  import EmpChangeChart from './EmpChangeChart.vue'
  import EmpHireTimeRatioChart from './EmpHireTimeRatioChart.vue'
  import NativePlaceChart from './NativePlaceChart.vue'
  import SalaryCompoRatioChart from './SalaryCompoRatioChart.vue'
  import SalaryDistChart from './SalaryDistChart.vue'
  import SalaryMonthChart from './SalaryMonthChart.vue'
  import { validatenull } from "@/util/validate";
  import EmpEducationRatioChart from "./EmpEducationRatioChart";
  import EmpGenderRatioChart from "./EmpGenderRatioChart";

  export default {
    name: 'DataCenterStats',
    components: {
      EmpGenderRatioChart,
      EmpEducationRatioChart,
      DeptSalaryRatioChart,
      EmpAgeRatioChart,
      EmpChangeChart,
      EmpHireTimeRatioChart,
      NativePlaceChart,
      SalaryCompoRatioChart,
      SalaryDistChart,
      SalaryMonthChart
    },
    props: {
      infoData: {
        type: Object,
        default: () => ({})
      },
      infoLoading: {
        type: Boolean,
        default: true
      }
    },
    inject: ['$cusIds'],
    data() {
      return {
        // averageNameList: ['本月平均应发薪资', '本月平均实发薪资', '本月平均人力成本'],
        averageNameList: ['averageGrossSalaryForThisMonth', 'averageNetSalaryForThisMonth', 'averageLaborCostForThisMonth'],
        nativePlacePercentList: [],
        statsData: {
          empChange: {
            loading: true,
            pickDate: {},
            pickerOptions: {
              onPick: this.onPickDateEmpChange,
              disabledDate: this.disabledDateEmpChange
            },
            monthRange: [],
            monthStart: '',
            monthEnd: '',
            data: {
              v_92740007: []
            },
          },
          salaryMonth: {
            loading: true,
            pickDate: {},
            pickerOptions: {
              onPick: this.onPickDateSalaryMonth,
              disabledDate: this.disabledDateSalaryMonth
            },
            monthRange: [],
            monthStart: '',
            monthEnd: '',
            type: 'sum',
            data: {
              v_92740012: []
            }
          },
          salaryCompo: {
            loading: true,
            year: '',
            monthStart: '',
            monthEnd: '',
            data: {
              v_92740017: []
            }
          },
          salaryDist: {
            loading: true,
            year: '',
            monthStart: '',
            monthEnd: '',
            type: 'sf',
            data: {
              v_92740014: []
            }
          },
          deptSalary: {
            loading: true,
            year: '',
            monthStart: '',
            monthEnd: '',
            type: 'sf',
            data: {
              v_92740015: {}
            }
          },
          salaryType: {
            loading: true,
            year: '',
            monthStart: '',
            monthEnd: '',
            data: {
              v_92740013: {}
            }
          },
          empAge: {
            loading: true,
            data: {
              v_92740008: []
            }
          },
          empHireTime: {
            loading: true,
            data: {
              v_92740008: []
            }
          },
          costCenter: {
            loading: true,
            year: '',
            monthStart: '',
            monthEnd: '',
            type: 'sf',
            data: {
              v_92740016: {}
            }
          },
          empEducation: {
            loading: true,
            data: {
              v_92740018: []
            }
          },
          empGender: {
            loading: true,
            data: {
              v_92740019: []
            }
          }
        }
      }
    },
    computed: {
      cusIds() {
        return this.$cusIds();
      },
      getLang() {
        return localStorage.getItem('lang');
      }
    },
    created() {
      this.init()
    },
    methods: {
      init() {
        for (let type in this.statsData) {
          // 初始化参数
          if (this.statsData[type].monthRange && this.statsData[type].monthRange.length === 0) {
            this.statsData[type].monthRange = [this.$day().subtract(1, 'y').add(1, 'M').format('YYYY-MM'), this.$day().format('YYYY-MM')]
          }
          if (this.statsData[type].year === '') {
            this.statsData[type].year = this.$day().format('YYYY')
          }
          this.getStatsData(type)
        }
      },
      getStatsData(type) {
        // 组装参数
        this.genParams(type)
        this.statsData[type].loading = true
        let paramsNew = this.statsData[type];
        paramsNew.cusIds = this.cusIds;
        apiBoard[type](paramsNew).then(res => {
          this.statsData[type].data = {
            params: this.$clone(this.statsData[type]),
            ...res.data.data
          }
          this.statsData[type].loading = false
        })
      },
      genParams(type) {
        if (this.statsData[type].monthRange && this.statsData[type].monthRange.length) {
          this.statsData[type].monthStart = this.statsData[type].monthRange[0]
          this.statsData[type].monthEnd = this.statsData[type].monthRange[1]
        }
        if (this.statsData[type].year) {
          this.statsData[type].monthStart = `${this.statsData[type].year}-01`
          this.statsData[type].monthEnd = `${this.statsData[type].year}-12`
        }
      },
      nativePlaceSortPercent(percentList) {
        this.nativePlacePercentList = percentList
      },
      onPickDateEmpChange(pickDate) {
        this.statsData.empChange.pickDate = pickDate
      },
      disabledDateEmpChange(date) {
        const { minDate, maxDate } = this.statsData.empChange.pickDate
        if (minDate && !maxDate) {
          // 限制最大可选范围为12个月
          return this.$day(date).isBefore(this.$day(minDate).subtract(1, 'y').add(1, 'M'))
            || this.$day(date).isAfter(this.$day(minDate).add(1, 'y').subtract(1, 'M'))
        }
      },
      onPickDateSalaryMonth(pickDate) {
        this.statsData.salaryMonth.pickDate = pickDate
      },
      disabledDateSalaryMonth(date) {
        const { minDate, maxDate } = this.statsData.salaryMonth.pickDate
        if (minDate && !maxDate) {
          // 限制最大可选范围为12个月
          return this.$day(date).isBefore(this.$day(minDate).subtract(1, 'y').add(1, 'M'))
            || this.$day(date).isAfter(this.$day(minDate).add(1, 'y').subtract(1, 'M'))
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~@/air/assets/css/main.scss";
  .title-text {
    word-wrap: break-word;
    word-break: break-all;
  }
  .title-right {
    text-align: right;
  }
  .title-right .radio-group-v2 {
    min-width: 190px;
  }
  .chart-container {
    min-width: 1664px;
    
    .average-box {
      height: 200px;
    }
    .left-chart-container {
      min-width: 1242px;
      height: 400px;
      
      &.small-chart {
        min-width: 609px;
      }
    }
    .right-chart-container {
      width: 398px;
      height: 400px;
    }
  }
  .progress-container {
    overflow-y: auto;
    
    .el-progress {
      width: 254px;
      flex: 0 0 254px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    ::v-deep .el-progress__text {
      width: 65px;
      text-align: right;
      font-size: 14px !important;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      margin-left: 18px;
    }
  }
</style>
